export default __webpack_public_path__ + "static/media/LOGO_cbre.19909c08.png";